export default __webpack_public_path__ + "static/media/Asset-26.be51a7e5.png";